/**
 * @description 배열의 모든 항목을 검사하여 조건을 만족하는지 확인하는 함수
 * v-form의 검사 함수
 * @param items 검사 대상 배열
 * @param checks 검사 함수 배열
 */
export const validateArray = (items, checks) => {
    for (const item of items) {
        for (const { validator, errorMessage } of checks) {
            if (!validator(item)) {
                // 첫 번째 실패 지점에서 즉시 멈추고
                // 해당 체크의 메시지만 던집니다.
                throw new Error(errorMessage);
            }
        }
    }
};
/**
 * @description 객체의 모든 항목을 검사하여 조건을 만족하는지 확인하는 함수
 * @param item 검사 대상 객체
 * @param checks 검사 함수 배열
 */
export const validateObject = (item, checks) => {
    for (const { validator, errorMessage } of checks) {
        if (!validator(item)) {
            throw new Error(errorMessage);
        }
    }
};
